class APIUrls {
  static prodBackendURL: string = 'https://2023-dyslexico-csharp-production.azurewebsites.net/api/Dyslexico/';
  static stagingBackendURL: string =
    'https://dyslexico-csharp-staging-cwgzhhcchjhaebhj.centralus-01.azurewebsites.net/api/Dyslexico/';
  static localBackendURL: string = 'https://localhost:50721/api/Dyslexico/';

  static prodFrontendURL: string = 'https://dyslexi.co/';
  static stagingFrontendURL: string = 'https://dyslexico-react-prod-dyslexico-react-staging.azurewebsites.net/';
  static localFrontendURL: string = 'http://localhost:3000/';
  static currentEnvironment: 'Prod' | 'Staging' | 'Local' = (() => {
    const host = window.location.hostname;
    if (host === 'localhost') {
      return 'Local';
    } else if (host.includes('staging')) {
      return 'Staging';
    } else {
      return 'Prod';
    }
  })();

  static getBackendUrl() {
    if (this.currentEnvironment === 'Local') {
      return this.localBackendURL;
    } else if (this.currentEnvironment === 'Staging') {
      return this.stagingBackendURL;
    } else {
      return this.prodBackendURL;
    }
  }
  static getFrontendUrl() {
    if (this.currentEnvironment === 'Local') {
      return this.localFrontendURL;
    } else if (this.currentEnvironment === 'Staging') {
      return this.stagingFrontendURL;
    } else {
      return this.prodFrontendURL;
    }
  }
}
export default APIUrls;
